export const initialState = {
  user: sessionStorage.user && JSON.parse(sessionStorage.user).user,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'USER_DATA':
      return {
        ...state,
        user: action.user,
      };
    default:
      return state;
  }
};

export default reducer;
